import {ClientDocumentType} from "../../../constants";

type documentsSettingType = {
    front?: any,
    back?: any,
    label: string,
    firstYear?: any,
    secondYear?: any

}

export const getDocument = (fieldName, values) => {
    return (docType, side) => {
        return Array.isArray(values[fieldName]) && values[fieldName].find((doc) => {
            return (doc.document === docType && doc.variant === side);
        })
    }
}

export const ageCalculator = (data: string) => {
    const dob = new Date(data);
    //calculate month difference from current date in time
    const month_diff = Date.now() - dob.getTime();

    //convert the calculated difference in date format
    const age_dt = new Date(month_diff);

    //extract year from date
    const year = age_dt.getUTCFullYear();

    //now calculate the age of the user
    const age = Math.abs(year - 1970);
    return age
    //display the calculated age
}

export const getDocumentsSetting = (dt): documentsSettingType => {
    return documentsSetting[dt] || {} as documentsSettingType
}

export const documentsSetting = {
    "drivingLicence": {
        front: {
            additionalDetials: {
                "documentType": ClientDocumentType.IDENTITY_DOCUMENT,
                "documentSubType": "front",
                "documentKey": "uploadDriversLicenseGEN1GWT",
            }
        },
        back: {
            additionalDetials: {
                "documentType": ClientDocumentType.IDENTITY_DOCUMENT,
                "documentSubType": "back",
                "documentKey": "uploadDriversLicenseBackGEN1GWT",
            }
        },
        label: "Drivers License"
    },
    "passport": {
        front: {
            additionalDetials: {
                "documentType": ClientDocumentType.IDENTITY_DOCUMENT,
                "documentSubType": "front",
                "documentKey": "uploadPassportGEN1GWT",
            }
        },
        back: {
            additionalDetials: {
                "documentType": ClientDocumentType.IDENTITY_DOCUMENT,
                "documentSubType": "back",
                "documentKey": "uploadPassportBackGEN1GWT",
            }
        },
        label: "Passport"
    },
    "Tax Returns": {
        firstYear: {
            additionalDetials: {
                "documentType": ClientDocumentType.TAX_DOCUMENT,
                "docSubName": "Tax Returns",
                "documentSubType": "YEAR_ONE",
                "documentKey": "uploadGWTIncomeVerificationYear1",
            }
        },
        secondYear: {
            additionalDetials: {
                "documentType": ClientDocumentType.TAX_DOCUMENT,
                "docSubName": "Tax Returns",
                "documentSubType": "YEAR_TWO",
                "documentKey": "uploadGWTIncomeVerificationYear2",
            }
        },
        label: "Tax Returns"
    },
    "W2’s": {
        firstYear: {
            additionalDetials: {
                "documentType": ClientDocumentType.TAX_DOCUMENT,
                "docSubName": "W2’s",
                "documentSubType": "YEAR_ONE",
                "documentKey": "uploadGWTIncomeVerificationYear1",
            }
        },
        secondYear: {
            additionalDetials: {
                "documentType": ClientDocumentType.TAX_DOCUMENT,
                "docSubName": "W2’s",
                "documentSubType": "YEAR_TWO",
                "documentKey": "uploadGWTIncomeVerificationYear2",
            }
        },
        label: "W2’s"
    },
    "1099’s": {
        firstYear: {
            additionalDetials: {
                "documentType": ClientDocumentType.TAX_DOCUMENT,
                "docSubName": "1099’s",
                "documentSubType": "YEAR_ONE",
                "documentKey": "uploadGWTIncomeVerificationYear1",
            }
        },
        secondYear: {
            additionalDetials: {
                "documentType": ClientDocumentType.TAX_DOCUMENT,
                "docSubName": "1099’s",
                "documentSubType": "YEAR_TWO",
                "documentKey": "uploadGWTIncomeVerificationYear2",
            }
        },
        label: "1099’s"
    },
}

export const fields = {
    annualIncome: "annualIncome",
    indIncomeLastYearAnnualSalary: "indIncomeLastYearAnnualSalary",
    netWorth: "netWorth",
    beginDistributions: "beginDistributions",
    childHIncome: "childHouseHoldingIncome",
    contributionAmount: "contributionAmount",
    currentKaiZenPolicy: "currentKaiZenPolicy",
    dateOfBirth: "dateOfBirth",
    dob: "dob",
    describeRelationship: "describeRelationship",
    documentType: "documentType",
    email: "email",
    endDistributions: "endDistributions",
    financiallyDependent: "financiallyDependent",
    firstName: "firstName",
    gen1documentType: "gen1documentType",
    gen1Email: "gen1Email",
    gen1Phone: "gen1Phone",

    gen1PolicyNumber: "gen1PolicyNumber",
    gen1TranceNo: "gen1TranceNo",
    gen1ICN: "gen1ICN",
    gen1DeathBAP: "gen1DeathBAP",

    gender: "gender",
    hasCurrentInsuranceCoverage: "hasCurrentInsuranceCoverage",
    healthType: "healthType",
    identityDocs: 'identityDocs',
    identityDocsGen1: "identityDocsGen1",
    lastName: "lastName",
    otherCompanyName: "otherCompanyName",
    otherDeathBenefitAmount: "otherDeathBenefitAmount",
    giftorInsuranceCarrier: "giftorInsuranceCarrier",
    giftorDeathBenefit: "giftorDeathBenefit",
    otherPolicyNumber: "otherPolicyNumber",
    giftorInsurable: "giftorInsurable",
    otherType: "otherType",
    phoneNumber: "phoneNumber",
    relationToGen2Client: "relation",
    otherRelation: "otherRelation",
    taxDocument: "taxDocument",
    taxDocumentType: "taxDocumentType",
    tobacco: "tobacco",
    employeeSSN:"employeeSSN",
    includeIllustration: "includeIllustration",
    verifyAssets:"verifyAssets",
    verifyLiabilities:"verifyLiabilities",
}

// temp file save directory to save on s3 Bucket
export const tempEnrollmentDirectory = "a6e716b1-d2c2-4ebc-ab2d-3921d5f66112";

export type payloadType = {
    "age": number,
    "agentId"?: number,
    "annualIncome": number,
    "carrierId": number,
    "clientType": number,
    "contributionAmount": number,
    "currentKaiZenPolicy": boolean,
    "describeRelationship": string,
    "dob": string,
    "dateOfBirth": string,
    "documents": any[],
    "email": string,
    "enrollmentId": string,
    "firstName": string,
    "gen1PolicyNumber": string,
    "gen1TranceNo": number,
    "hasCurrentInsuranceCoverage": boolean,
    "healthType": string,
    "householdAnnualIncome": number,
    "imo": number,
    "lastName": string,
    "otherCompanyName": string,
    "otherDeathBenefitAmount": string,
    "otherPolicyNumber": string,
    "otherRelation": string,
    "otherType": string,
    "phoneNumber": string,
    "relation": string,
    "relationToGen2Client": string,
    "strategyId": number,
    "tobacco": string,
    "financiallyDependent": string
}

export const addSuffix = (str?: string | number): typeof fields => {
    let suffixObject: any = {}
    Object.keys(fields).forEach((key) => {
        suffixObject[key] = str ? `${fields[key]}_${str}` : fields[key]
    })
    return suffixObject
}

export function getFormIdFromString(str: string) {
    return str.split("_")[1]
}

export function NullForm(formId) {
    let formNames = addSuffix(formId.toString());
    let values = {};
    const childFormFields = ["firstName", "lastName", "email", "dateOfBirth", "relationship", "childHIncome", "contributionAmount", "phoneNumber", "dateOfBirth"]
    childFormFields.forEach((element) => {
        values[formNames[element]] = undefined
    })
    return values
}

export function createArray(N, from = 1) {
    let newArr: number[] = [];
    for (let i = from; i <= N; i++) {
        newArr.push(i);
    }
    return newArr;
}

export enum Member {
    Parent = "parent",
    GrandParent = "grandParent",
    Other = "other",
}
export enum Financial {
    Independent = "independent",
    Dependent = "dependent",
}
export enum FinancialEnum {
    Independent,
    Dependent
}